// export const base_url = "https://api-renew.jumbochain.org/api/";
// export const base_url = "https://test-renew.jumbochain.org/api/";

export const base_url = `${process.env.REACT_APP_API_URL}/api/`;
console.log("base_url======", base_url);
export const auth = window.sessionStorage.getItem("userToken");
